// extracted by mini-css-extract-plugin
export default {"note":"CreateNoteModal_note__sHnLq","noteButton":"CreateNoteModal_noteButton__cUPzi"};